(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["50-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fiftyBuyCarousel) return;

    var state = new Map();

    function scrollThumbIntoView(track, thumb) {
      if (!track || !thumb) return;

      var trackRect = track.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var delta = (thumbRect.left - trackRect.left) - (track.clientWidth - thumb.offsetWidth) / 2;
      var max = track.scrollWidth - track.clientWidth;
      var target = Math.max(0, Math.min(track.scrollLeft + delta, max));

      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function updateLightboxImage(sectionState) {
      if (!sectionState.lightboxImg) return;

      var slide = sectionState.slides[sectionState.current];
      var img = slide && slide.querySelector('img');
      var src = (slide && slide.getAttribute('data-fullsrc')) || (img && (img.currentSrc || img.src));
      if (!src) return;

      sectionState.lightboxImg.setAttribute('src', src);
      sectionState.lightboxImg.setAttribute('alt', (img && img.alt) || '');
    }

    function openFullscreen(sectionState) {
      if (!sectionState.lightbox || !sectionState.lightboxImg) return;

      updateLightboxImage(sectionState);
      sectionState.lightbox.classList.add('is-open');
      sectionState.lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeFullscreen(sectionState) {
      if (!sectionState.lightbox) return;

      sectionState.lightbox.classList.remove('is-open');
      sectionState.lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function setActive(sectionState, nextIndex) {
      var slides = sectionState.slides;
      var thumbs = sectionState.thumbs;
      if (!slides.length) return;

      slides[sectionState.current].classList.remove('is-active');
      if (thumbs.length) thumbs[sectionState.current].classList.remove('is-active');

      sectionState.current = (nextIndex + slides.length) % slides.length;

      slides[sectionState.current].classList.add('is-active');
      if (thumbs.length) thumbs[sectionState.current].classList.add('is-active');

      if (sectionState.track && thumbs.length) {
        scrollThumbIntoView(sectionState.track, thumbs[sectionState.current]);
      }

      if (sectionState.lightbox && sectionState.lightbox.classList.contains('is-open')) {
        updateLightboxImage(sectionState);
      }
    }

    var boundForms = new WeakSet();

    // Section scripts are injected via content_for_header and execute before the
    // deferred theme.js, so theme.AjaxProduct may not exist yet on first run.
    // Bind now if we can, otherwise once all deferred scripts have executed.
    // Without JS (or if binding never happens) the form still posts to /cart/add.
    function initAddToCart(section) {
      var form = section.querySelector('[data-buy-form]');
      if (!form || boundForms.has(form)) return;

      function bind() {
        if (boundForms.has(form)) return;
        if (!window.theme || !window.theme.AjaxProduct) return;
        boundForms.add(form);
        new window.theme.AjaxProduct(form, '[data-buy-add-to-cart]');
      }

      bind();
      if (!boundForms.has(form)) {
        document.addEventListener('DOMContentLoaded', bind, { once: true });
        window.addEventListener('load', bind, { once: true });
      }
    }

    function initSection(section) {
      if (!section) return;

      initAddToCart(section);

      if (state.has(section)) return;

      var slides = Array.from(section.querySelectorAll('.buy-50__slide'));
      if (!slides.length) return;

      var sectionState = {
        slides: slides,
        thumbs: Array.from(section.querySelectorAll('.buy-50__thumb')),
        track: section.querySelector('.buy-50__thumb-track'),
        prevBtn: section.querySelector('.buy-50__thumb-prev'),
        nextBtn: section.querySelector('.buy-50__thumb-next'),
        current: 0,
        thumbHandlers: []
      };

      sectionState.thumbs.forEach(function (thumb) {
        var handler = function () {
          setActive(sectionState, parseInt(thumb.dataset.thumb || '0', 10));
        };
        thumb.addEventListener('click', handler);
        sectionState.thumbHandlers.push({ thumb: thumb, handler: handler });
      });

      if (sectionState.prevBtn) {
        sectionState.onPrev = function () {
          setActive(sectionState, sectionState.current - 1);
        };
        sectionState.prevBtn.addEventListener('click', sectionState.onPrev);
      }

      if (sectionState.nextBtn) {
        sectionState.onNext = function () {
          setActive(sectionState, sectionState.current + 1);
        };
        sectionState.nextBtn.addEventListener('click', sectionState.onNext);
      }

      sectionState.surface = section.querySelector('.buy-50__slides');
      if (sectionState.surface) {
        var surface = sectionState.surface;
        var startX = 0;
        var startY = 0;
        var tracking = false;
        var SWIPE_THRESHOLD = 40;
        var EDGE_RATIO = 0.25;

        sectionState.onSurfaceTouchStart = function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        };

        sectionState.onSurfaceTouchEnd = function (event) {
          if (!tracking) return;
          tracking = false;

          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;

          setActive(sectionState, sectionState.current + (dx < 0 ? 1 : -1));
        };

        sectionState.onSurfaceClick = function (event) {
          var rect = surface.getBoundingClientRect();
          if (!rect.width) return;

          var ratio = (event.clientX - rect.left) / rect.width;
          if (ratio <= EDGE_RATIO) {
            setActive(sectionState, sectionState.current - 1);
          } else if (ratio >= 1 - EDGE_RATIO) {
            setActive(sectionState, sectionState.current + 1);
          }
        };

        surface.addEventListener('touchstart', sectionState.onSurfaceTouchStart, { passive: true });
        surface.addEventListener('touchend', sectionState.onSurfaceTouchEnd, { passive: true });
        surface.addEventListener('click', sectionState.onSurfaceClick);
      }

      sectionState.fullscreenBtn = section.querySelector('[data-buy-fullscreen]');
      sectionState.lightbox = section.querySelector('[data-buy-lightbox]');
      sectionState.lightboxImg = section.querySelector('[data-buy-lightbox-img]');

      if (sectionState.fullscreenBtn) {
        sectionState.onFullscreenOpen = function () {
          openFullscreen(sectionState);
        };
        sectionState.fullscreenBtn.addEventListener('click', sectionState.onFullscreenOpen);
      }

      if (sectionState.lightbox) {
        var LB_SWIPE_THRESHOLD = 40;
        var lbStartX = 0;
        var lbStartY = 0;
        var lbTracking = false;

        sectionState.onLightboxTouchStart = function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          lbTracking = true;
          lbStartX = event.touches[0].clientX;
          lbStartY = event.touches[0].clientY;
        };

        sectionState.onLightboxTouchEnd = function (event) {
          if (!lbTracking) return;
          lbTracking = false;

          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          var dx = touch.clientX - lbStartX;
          var dy = touch.clientY - lbStartY;
          if (Math.abs(dx) < LB_SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;

          setActive(sectionState, sectionState.current + (dx < 0 ? 1 : -1));
        };

        sectionState.onLightboxClick = function (event) {
          if (
            event.target.hasAttribute('data-buy-lightbox-overlay') ||
            event.target.closest('[data-buy-lightbox-close]')
          ) {
            closeFullscreen(sectionState);
          }
        };

        sectionState.lightbox.addEventListener('touchstart', sectionState.onLightboxTouchStart, { passive: true });
        sectionState.lightbox.addEventListener('touchend', sectionState.onLightboxTouchEnd, { passive: true });
        sectionState.lightbox.addEventListener('click', sectionState.onLightboxClick);

        sectionState.onLightboxKeydown = function (event) {
          if (event.key === 'Escape' || event.keyCode === 27) {
            closeFullscreen(sectionState);
          }
        };
        document.addEventListener('keydown', sectionState.onLightboxKeydown);
      }

      state.set(section, sectionState);
    }

    function destroySection(section) {
      var sectionState = state.get(section);
      if (!sectionState) return;

      sectionState.thumbHandlers.forEach(function (entry) {
        entry.thumb.removeEventListener('click', entry.handler);
      });

      if (sectionState.prevBtn && sectionState.onPrev) {
        sectionState.prevBtn.removeEventListener('click', sectionState.onPrev);
      }

      if (sectionState.nextBtn && sectionState.onNext) {
        sectionState.nextBtn.removeEventListener('click', sectionState.onNext);
      }

      if (sectionState.surface) {
        if (sectionState.onSurfaceTouchStart) {
          sectionState.surface.removeEventListener('touchstart', sectionState.onSurfaceTouchStart);
        }
        if (sectionState.onSurfaceTouchEnd) {
          sectionState.surface.removeEventListener('touchend', sectionState.onSurfaceTouchEnd);
        }
        if (sectionState.onSurfaceClick) {
          sectionState.surface.removeEventListener('click', sectionState.onSurfaceClick);
        }
      }

      if (sectionState.fullscreenBtn && sectionState.onFullscreenOpen) {
        sectionState.fullscreenBtn.removeEventListener('click', sectionState.onFullscreenOpen);
      }
      if (sectionState.lightbox) {
        if (sectionState.onLightboxTouchStart) {
          sectionState.lightbox.removeEventListener('touchstart', sectionState.onLightboxTouchStart);
        }
        if (sectionState.onLightboxTouchEnd) {
          sectionState.lightbox.removeEventListener('touchend', sectionState.onLightboxTouchEnd);
        }
        if (sectionState.onLightboxClick) {
          sectionState.lightbox.removeEventListener('click', sectionState.onLightboxClick);
        }
      }
      if (sectionState.onLightboxKeydown) {
        document.removeEventListener('keydown', sectionState.onLightboxKeydown);
      }
      closeFullscreen(sectionState);

      state.delete(section);
    }

    function findSectionById(sectionId) {
      return document.querySelector('[data-section-type="50-buy"][data-section-id="' + sectionId + '"]');
    }

    document.querySelectorAll('[data-section-type="50-buy"]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      initSection(findSectionById(event.detail.sectionId));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      destroySection(findSectionById(event.detail.sectionId));
    });

    window.__fiftyBuyCarousel = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["50-chapter-3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fiftyChapter3Carousel) return;

    var state = new Map();

    function getCards(track) {
      return track.querySelectorAll('.chapter-3-50__card');
    }

    function getCenteredScrollLeft(track, card) {
      var target = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      var max = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(target, max));
    }

    function setActive(indicators, index) {
      indicators.forEach(function (indicator, i) {
        var isActive = i === index;
        indicator.classList.toggle('is-active', isActive);
        indicator.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function getClosestIndex(track) {
      var cards = getCards(track);
      var nearestIndex = 0;
      var nearestDistance = Infinity;
      var viewportCenter = track.scrollLeft + (track.clientWidth / 2);

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        var distance = Math.abs(cardCenter - viewportCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function initSection(section) {
      if (!section || state.has(section)) return;

      var track = section.querySelector('[data-carousel-track]');
      var indicators = Array.from(section.querySelectorAll('[data-carousel-indicator]'));
      if (!track || !indicators.length) return;

      var ticking = false;
      var onTrackScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setActive(indicators, getClosestIndex(track));
          ticking = false;
        });
      };

      var onResize = function () {
        setActive(indicators, getClosestIndex(track));
      };

      var indicatorHandlers = indicators.map(function (indicator) {
        var handler = function () {
          var index = Number(indicator.getAttribute('data-index'));
          var card = getCards(track)[index];
          if (!card) return;

          track.scrollTo({
            left: getCenteredScrollLeft(track, card),
            behavior: 'smooth'
          });
          setActive(indicators, index);
        };

        indicator.addEventListener('click', handler);
        return { indicator: indicator, handler: handler };
      });

      track.addEventListener('scroll', onTrackScroll, { passive: true });
      window.addEventListener('resize', onResize);
      setActive(indicators, 0);

      state.set(section, {
        track: track,
        onTrackScroll: onTrackScroll,
        onResize: onResize,
        indicatorHandlers: indicatorHandlers
      });
    }

    function destroySection(section) {
      var sectionState = state.get(section);
      if (!sectionState) return;

      sectionState.track.removeEventListener('scroll', sectionState.onTrackScroll);
      window.removeEventListener('resize', sectionState.onResize);

      sectionState.indicatorHandlers.forEach(function (entry) {
        entry.indicator.removeEventListener('click', entry.handler);
      });

      state.delete(section);
    }

    function findSectionById(sectionId) {
      return document.querySelector('[data-section-type="50-chapter-3"][data-section-id="' + sectionId + '"]');
    }

    document.querySelectorAll('[data-section-type="50-chapter-3"]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      initSection(findSectionById(event.detail.sectionId));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      destroySection(findSectionById(event.detail.sectionId));
    });

    window.__fiftyChapter3Carousel = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["50-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fiftyHeroGsap) return;

    var CFG = {
      spotlight: {
        smoothness: 0.01, 
        fadeIn: 1,
        fadeOut: 1, 
      },
    };

    var state = { sections: new Map() };

    function ensureGsap() {
      if (!window.gsap || !window.ScrollTrigger) return false;
      window.gsap.registerPlugin(window.ScrollTrigger);
      return true;
    }

    function resolveProductImg(section) {
      return section.querySelector('.hero-50__product-img img') ||
        section.querySelector('img.hero-50__product-img') ||
        section.querySelector('.hero-50__product img');
    }

    function resolveFadeTargets(section) {
      return section.querySelectorAll('.hero-50__content, .hero-50__bg');
    }

    function parsePx(value) {
      var parsed = parseFloat(value || '0');
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function getHeaderOffset() {
      var rootStyles = window.getComputedStyle(document.documentElement);
      var h1 = parsePx(rootStyles.getPropertyValue('--header-height'));
      var h2 = parsePx(rootStyles.getPropertyValue('--header-group-height'));
      var cssOffset = Math.max(h1, h2);
      if (cssOffset > 0) return cssOffset;
      var el = document.querySelector('header.header-wrapper, .shopify-section-group-header-group');
      return el ? el.getBoundingClientRect().height : 0;
    }

    function initSpotlight(section, spotEl, ss) {
      if (!spotEl) return;
      var gsap = window.gsap;
      var rect0 = section.getBoundingClientRect();

      gsap.set(spotEl, { x: rect0.width / 2, y: rect0.height / 2 });

      var quickX = gsap.quickTo(spotEl, 'x', { duration: CFG.spotlight.smoothness, ease: 'power2.out' });
      var quickY = gsap.quickTo(spotEl, 'y', { duration: CFG.spotlight.smoothness, ease: 'power2.out' });

      function onMove(e) {
        var rect = section.getBoundingClientRect();
        quickX(e.clientX - rect.left);
        quickY(e.clientY - rect.top);
        gsap.to(spotEl, { opacity: 1, duration: CFG.spotlight.fadeIn, overwrite: 'auto' });
      }

      function onLeave() {
        gsap.to(spotEl, { opacity: 0, duration: CFG.spotlight.fadeOut, overwrite: 'auto' });
      }

      section.addEventListener('mousemove', onMove);
      section.addEventListener('mouseleave', onLeave);

      ss.onMove  = onMove;
      ss.onLeave = onLeave;
    }    

    function initSection(section) {
      if (!section || state.sections.has(section)) return;
      if (!ensureGsap()) return;

      var gsap = window.gsap;
      var targetImg   = resolveProductImg(section);
      if (!targetImg) return;

      var spotEl      = section.querySelector('.hero-50__spotlight');
      var fadeTargets = resolveFadeTargets(section);

      gsap.set(targetImg, { rotation: 0, scale: 1, transformOrigin: '58% 52%' });
      if (fadeTargets.length) gsap.set(fadeTargets, { opacity: 1 });

      var scrollTween = gsap.to(targetImg, {
        rotation: 45,
        scale: 1.12,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: function () { return 'top top+=' + getHeaderOffset(); },
          end: '+=100%',
          scrub: true,
          invalidateOnRefresh: true
        }
      });

      var fadeTween = null;
      if (fadeTargets.length) {
        fadeTween = gsap.to(fadeTargets, {
          opacity: 0,
          ease: 'power3.inOut',
          scrollTrigger: {
            trigger: section,
            start: function () { return 'top top+=' + getHeaderOffset(); },
            end:   function () { return 'bottom top+=' + getHeaderOffset(); },
            scrub: true,
            invalidateOnRefresh: true
          }
        });
      }

      var ss = {
        scrollTween:  scrollTween,
        fadeTween:    fadeTween,
        counterTween: null,
        titleEl:      null,
        originalText: null,
        onMove:       null,
        onLeave:      null,
      };

      initSpotlight(section, spotEl, ss);

      state.sections.set(section, ss);
      window.ScrollTrigger.refresh();
    }

    function removeSection(section) {
      if (!section) return;
      var ss = state.sections.get(section);
      if (!ss) return;

      if (ss.scrollTween)  ss.scrollTween.kill();
      if (ss.fadeTween)    ss.fadeTween.kill();
      if (ss.counterTween) ss.counterTween.kill();

      if (ss.onMove)  section.removeEventListener('mousemove',  ss.onMove);
      if (ss.onLeave) section.removeEventListener('mouseleave', ss.onLeave);

      if (ss.titleEl && ss.originalText) {
        ss.titleEl.textContent = ss.originalText;
      }

      state.sections.delete(section);
    }

    function findSectionById(sectionId) {
      return document.querySelector('[data-section-type="50-hero"][data-section-id="' + sectionId + '"]');
    }

    document.querySelectorAll('[data-section-type="50-hero"]').forEach(initSection);

    window.addEventListener('resize', function () {
      if (!window.ScrollTrigger) return;
      window.ScrollTrigger.refresh();
    });

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      initSection(findSectionById(event.detail.sectionId));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      removeSection(findSectionById(event.detail.sectionId));
    });

    window.__fiftyHeroGsap = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["50-release-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fiftyReleaseCountdown) return;

    var CFG = {
      spin: 150,
      ease: 'power2.out',
      days:    { duration: 1 },
      hours:   { duration: 1.5 },
      minutes: { duration: 2 },
    };

    var state = new Map();

    function pad(value, minDigits) {
      var result = String(Math.max(0, value));
      while (result.length < minDigits) result = '0' + result;
      return result;
    }

    function getTimeParts(target) {
      if (Number.isNaN(target)) {
        return { days: 0, hours: 0, minutes: 0 };
      }

      var diff = target - Date.now();
      if (diff < 0) diff = 0;

      var totalMinutes = Math.floor(diff / 60000);

      return {
        days: Math.floor(totalMinutes / 1440),
        hours: Math.floor((totalMinutes % 1440) / 60),
        minutes: totalMinutes % 60
      };
    }

    function updateDisplay(sectionState, parts) {
      sectionState.daysEl.textContent = pad(parts.days, 2);
      sectionState.hoursEl.textContent = pad(parts.hours, 2);
      sectionState.minutesEl.textContent = pad(parts.minutes, 2);
    }

    function startTimer(sectionState) {
      if (sectionState.timerId) {
        window.clearInterval(sectionState.timerId);
      }

      sectionState.timerId = window.setInterval(function () {
        render(sectionState);
      }, 30000);
    }

    function render(sectionState) {
      updateDisplay(sectionState, getTimeParts(sectionState.target));
    }

    function animateIntro(sectionState) {
      if (!window.gsap || Number.isNaN(sectionState.target)) {
        render(sectionState);
        startTimer(sectionState);
        return;
      }

      var targetParts = getTimeParts(sectionState.target);

      var proxy = {
        days:    targetParts.days    + CFG.spin,
        hours:   targetParts.hours   + CFG.spin,
        minutes: targetParts.minutes + CFG.spin
      };

      // While proxy is still above target: show proxy % 100 (continuous descent that wraps).
      // Once proxy reaches target: lock to the real value.
      function slotVal(raw, target) {
        var v = Math.round(raw);
        return v > target ? v % 100 : target;
      }

      sectionState.daysEl.textContent    = pad(slotVal(proxy.days,    targetParts.days),    2);
      sectionState.hoursEl.textContent   = pad(slotVal(proxy.hours,   targetParts.hours),   2);
      sectionState.minutesEl.textContent = pad(slotVal(proxy.minutes, targetParts.minutes), 2);

      var tl = window.gsap.timeline({
        onComplete: function () {
          sectionState.introTween = null;
          render(sectionState);
          startTimer(sectionState);
        }
      });
      sectionState.introTween = tl;

      tl.to(proxy, {
        days: targetParts.days,
        duration: CFG.days.duration,
        ease: CFG.ease,
        onUpdate: function () {
          sectionState.daysEl.textContent = pad(slotVal(proxy.days, targetParts.days), 2);
        }
      }, 0);

      tl.to(proxy, {
        hours: targetParts.hours,
        duration: CFG.hours.duration,
        ease: CFG.ease,
        onUpdate: function () {
          sectionState.hoursEl.textContent = pad(slotVal(proxy.hours, targetParts.hours), 2);
        }
      }, 0);

      tl.to(proxy, {
        minutes: targetParts.minutes,
        duration: CFG.minutes.duration,
        ease: CFG.ease,
        onUpdate: function () {
          sectionState.minutesEl.textContent = pad(slotVal(proxy.minutes, targetParts.minutes), 2);
        }
      }, 0);
    }

    function initSection(section) {
      if (!section || state.has(section)) return;

      var daysEl = section.querySelector('[data-release-days]');
      var hoursEl = section.querySelector('[data-release-hours]');
      var minutesEl = section.querySelector('[data-release-minutes]');
      if (!daysEl || !hoursEl || !minutesEl) return;

      var targetValue = section.getAttribute('data-target-datetime') || '';
      var sectionState = {
        daysEl: daysEl,
        hoursEl: hoursEl,
        minutesEl: minutesEl,
        target: targetValue ? new Date(targetValue).getTime() : NaN,
        timerId: null,
        introTween: null
      };

      state.set(section, sectionState);

      if (!window.IntersectionObserver) {
        animateIntro(sectionState);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        animateIntro(sectionState);
      }, { threshold: 0.15 });

      observer.observe(section);
    }

    function destroySection(section) {
      var sectionState = state.get(section);
      if (!sectionState) return;

      if (sectionState.timerId) {
        window.clearInterval(sectionState.timerId);
      }

      if (sectionState.introTween) {
        sectionState.introTween.kill();
      }

      state.delete(section);
    }

    function findSectionById(sectionId) {
      return document.querySelector('[data-section-type="50-release-countdown"][data-section-id="' + sectionId + '"]');
    }

    document.querySelectorAll('[data-section-type="50-release-countdown"]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      initSection(findSectionById(event.detail.sectionId));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      destroySection(findSectionById(event.detail.sectionId));
    });

    window.__fiftyReleaseCountdown = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["50-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fiftyStickyBar) return;

    var CFG = {
      show: {
        duration: 0.45,
        ease:'power1.out',
        y:'0%',      
      },
      hide: {
        duration: 0.30,
        ease: 'power2.in',
        y: '110%',
      },
      showAfterPx: null,

    };

    var state = new Map();

    function initSection(bar) {
      if (!bar || state.has(bar)) return;
      if (!window.gsap) return;

      var gsap = window.gsap;
      var threshold = CFG.showAfterPx !== null
        ? CFG.showAfterPx
        : (Number(bar.getAttribute('data-show-after-px')) || 40);

      var topBtn = bar.querySelector('[data-scroll-top]');
      var visible = false;

      gsap.set(bar, { y: '110%', opacity: 0, pointerEvents: 'none' });

      function show() {
        if (visible) return;
        visible = true;
        gsap.to(bar, {
          y:        CFG.show.y,
          opacity:  1,
          duration: CFG.show.duration,
          ease:     CFG.show.ease,
          overwrite: 'auto',
          onStart: function () { gsap.set(bar, { pointerEvents: 'auto' }); },
        });
      }

      function hide() {
        if (!visible) return;
        visible = false;
        gsap.to(bar, {
          y:        CFG.hide.y,
          opacity:  0,
          duration: CFG.hide.duration,
          ease:     CFG.hide.ease,
          overwrite: 'auto',
          onComplete: function () { gsap.set(bar, { pointerEvents: 'none' }); },
        });
      }

      function updateVisibility() {
        if (window.scrollY > threshold) { show(); } else { hide(); }
      }

      var onTopClick = null;
      if (topBtn) {
        onTopClick = function () {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
        topBtn.addEventListener('click', onTopClick);
      }

      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);

      state.set(bar, {
        updateVisibility: updateVisibility,
        topBtn:           topBtn,
        onTopClick:       onTopClick,
      });
    }

    function destroySection(bar) {
      var ss = state.get(bar);
      if (!ss) return;

      window.removeEventListener('scroll', ss.updateVisibility);
      window.removeEventListener('resize', ss.updateVisibility);

      if (ss.topBtn && ss.onTopClick) {
        ss.topBtn.removeEventListener('click', ss.onTopClick);
      }

      state.delete(bar);
    }

    function findSectionById(sectionId) {
      return document.querySelector('[data-section-type="50-sticky-bar"][data-section-id="' + sectionId + '"]');
    }

    document.querySelectorAll('[data-section-type="50-sticky-bar"]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      initSection(findSectionById(event.detail.sectionId));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      destroySection(findSectionById(event.detail.sectionId));
    });

    window.__fiftyStickyBar = true;
  })();

  } catch(e) { console.error(e); }
})();
})();
